// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2381":"59950b8873cfffd4","9769":"921470d0d8b0204e"}[chunkId] + ".css";
};